import React, { Component } from 'react'
import classnames from 'classnames'

import { AppContext } from '../../App'

import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import Typography from '@material-ui/core/Typography'
import Paper from '@material-ui/core/Paper'
import Checkbox from '@material-ui/core/Checkbox'
import Button from '@material-ui/core/Button'
import EditIcon from '@material-ui/icons/Edit'
import AddIcon from '@material-ui/icons/Add'
import DeleteIcon from '@material-ui/icons/Delete'
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward'
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward'

import SearchIcon from '@material-ui/icons/Search'
import CloseIcon from '@material-ui/icons/Close'
import IconButton from '@material-ui/core/IconButton'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import TextField from '@material-ui/core/TextField'
import FormGroup from '@material-ui/core/FormGroup'
import Grid from '@material-ui/core/Grid'

import { Link } from 'react-router-dom'

import {
  getProductsGrouped,
  deleteProduct,
  reoderProducts
} from '../../services/api'
import { authenticated } from '../../services/auth'
import { filter } from '../../services/filter'

import Loader from '../../components-utils/Loader'
import DeleteDialog from '../../components-utils/DeleteDialog'

import './Products.css'

class Products extends Component {
  state = {
    openDialog: false,
    filtering: true,
    searchText: ''
  }

  async componentDidMount() {
    try {
      const auth = authenticated()
      const categories = await getProductsGrouped(auth.currentMerchant.code)
      this.setState({
        categories,
        merchantCode: auth.currentMerchant.code
      })
    } catch (error) {
      this.setState(
        { categories: [] },
        this.props.snackbar(
          'Une erreur est survenue pendant la récupération des données. Merci de recharger la page',
          'error'
        )
      )
    }
  }
  selectProduct = (id, categorieid) => () => {
    this.setState({
      selected: this.state.selected === id ? undefined : id,
      selected_cat: this.state.selected === id ? undefined : categorieid
    })
  }

  deleteProduct = async () => {
    const { snackbar } = this.props
    const { merchantCode } = this.state
    try {
      await deleteProduct(this.state.itemToDelete, merchantCode)
      const categories = await getProductsGrouped(merchantCode)
      this.setState({ categories, filtered: undefined }, () =>
        snackbar(`Élément supprimé`)
      )
    } catch (error) {
      console.error(error)
      snackbar(error.error, 'error')
    }
    this.closeDeleteDialog()
  }

  openDeleteDialog = id => e => {
    e.stopPropagation()
    this.setState({
      openDialog: true,
      itemToDelete: id
    })
  }
  closeDeleteDialog = () => {
    this.setState({ openDialog: false })
  }

  reorder = (target, position) => async e => {
    e.stopPropagation()
    const { selected, merchantCode } = this.state
    const { snackbar } = this.props
    try {
      const categories = await reoderProducts(
        merchantCode,
        selected,
        position,
        target
      )
      this.setState({ categories })
    } catch (e) {
      snackbar(
        'Une erreur est survenue pendant la réorganisation. veuillez réessayer',
        'error'
      )
    }
  }

  changeSearch = e => {
    this.setState({ searchText: e.target.value })
  }
  toggleSearch = () => {
    this.setState(
      state => ({ filtering: !state.filtering }),
      () => {
        if (this.state.filtering) {
          document.getElementById('sp-products--searchinput').focus()
        }
      }
    )
  }
  research = e => {
    e.preventDefault()
    const { categories, searchText } = this.state
    if (searchText !== '') {
      const results = categories.reduce(
        (acc, categorie) => [...acc, ...filter(categorie.products, searchText)],
        []
      )
      this.setState({ filtered: results })
    } else {
      this.setState({ filtered: undefined })
    }
  }
  renderLoader() {
    return <Loader loading={true} />
  }

  renderProducts(products, categorieid) {
    const { selected, selected_cat } = this.state
    return (
      <TableBody
        key={
          categorieid !== undefined ? 'categorie-' + categorieid : 'filtered'
        }
      >
        {products.length > 0 ? (
          products.map(product => {
            const {
              id,
              value: { technicalLabel }
            } = product
            return (
              <TableRow
                key={id}
                className="sp-products--product"
                onClick={this.selectProduct(id, categorieid)}
                role="checkbox"
                aria-checked={selected === id}
                selected={selected === id}
              >
                <TableCell
                  padding="checkbox"
                  className="sp-products--checkboxcell"
                >
                  <Checkbox
                    checked={selected === id}
                    value={`selected-${id}`}
                    color="primary"
                  />
                </TableCell>
                <TableCell>{technicalLabel}</TableCell>
                <TableCell numeric className="sp-products--rowbuttons">
                  {selected === undefined && (
                    <IconButton onClick={this.openDeleteDialog(id)}>
                      <DeleteIcon />
                    </IconButton>
                  )}
                  {selected !== undefined &&
                    selected_cat !== undefined &&
                    selected_cat === categorieid &&
                    selected !== id && (
                      <div>
                        <IconButton onClick={this.reorder(id, 'after')}>
                          <ArrowDownwardIcon />
                        </IconButton>
                        <IconButton onClick={this.reorder(id, 'before')}>
                          <ArrowUpwardIcon />
                        </IconButton>
                      </div>
                    )}
                </TableCell>
              </TableRow>
            )
          })
        ) : (
          <TableRow>
            <TableCell colSpan="3">Aucun produit</TableCell>
          </TableRow>
        )}
      </TableBody>
    )
  }
  renderFiltered() {
    const { filtered } = this.state
    return this.renderProducts(filtered)
  }
  renderTable(categorie) {
    return [
      <TableBody key={categorie.value.technicalLabel}>
        <TableRow>
          <TableCell className="categorie-title" colSpan="3">
            <Typography variant="subtitle1">
              {categorie.value.technicalLabel}
            </Typography>
          </TableCell>
        </TableRow>
      </TableBody>,
      this.renderProducts(categorie.products, categorie.id)
    ]
  }

  renderTables() {
    const { categories } = this.state
    return categories.map(
      categorie =>
        categorie.products.length > 0 ? this.renderTable(categorie) : undefined
    )
  }

  renderPage() {
    const { filtered, filtering, selected, searchText, openDialog } = this.state
    const paperClasses = classnames('sp-products--page', {
      'sp-products--page__filtering': filtering
    })
    const cardClasses = classnames('sp-products--card', {
      'sp-products--card__filtering': filtering
    })
    const tableClasses = classnames('sp-products--table', {
      'sp-products--table__filtering': filtering
    })
    return [
      <Paper key="page" className={paperClasses}>
        <Card key="header" className={cardClasses}>
          <CardHeader
            action={
              <IconButton onClick={this.toggleSearch}>
                {filtering ? <CloseIcon /> : <SearchIcon />}
              </IconButton>
            }
            title="Produits"
          />
          <Typography variant="subtitle1" className="sp-products--title" />
          {filtering && (
            <CardContent>
              <form onSubmit={this.research}>
                <FormGroup>
                  <Grid container spacing={8}>
                    <Grid item xs={12} sm={10}>
                      <TextField
                        id="sp-products--searchinput"
                        label="Votre recherche"
                        placeholder="Que recherchez-vous ?"
                        fullWidth
                        onChange={this.changeSearch}
                        value={searchText}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={2}
                      className="sp-products--searchbuttoncontainer"
                    >
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={this.research}
                        className="sp-products--searchbutton"
                      >
                        Rechercher
                      </Button>
                    </Grid>
                  </Grid>
                </FormGroup>
              </form>
            </CardContent>
          )}
        </Card>
        <Table className={tableClasses}>
          {filtered !== undefined ? this.renderFiltered() : this.renderTables()}
        </Table>
      </Paper>,
      <Link
        key="action"
        to={`/products/${selected !== undefined ? selected : 'new'}`}
      >
        <Button
          className="sp-products--actionbutton"
          variant="fab"
          color="secondary"
        >
          {selected === undefined ? <AddIcon /> : <EditIcon />}
        </Button>
      </Link>,
      <DeleteDialog
        key="dialog"
        openDialog={openDialog}
        elementName="produit"
        elementGender="m"
        closeDeleteDialog={this.closeDeleteDialog}
        deleteItem={this.deleteProduct}
      />
    ]
  }

  render() {
    const { categories } = this.state
    return categories !== undefined ? this.renderPage() : this.renderLoader()
  }
}

const enhanced = WrappedComponent => props => {
  return (
    <AppContext.Consumer>
      {app => <WrappedComponent {...props} snackbar={app.snackbar.open} />}
    </AppContext.Consumer>
  )
}
export default enhanced(Products)



// WEBPACK FOOTER //
// ./src/components/products/Products.js